import "./styles.sass";

export const SelectExamCard = ({
  competitiveExamsList,
  selectedExams,
  setSelectedExams,
  handleOpenPopup,
}) => {
  const exams = competitiveExamsList?.all || [];

  const handleExamChange = (exam) => {
    setSelectedExams((prev) =>
      prev.includes(exam)
        ? prev.filter((item) => item !== exam)
        : [...prev, exam],
    );
  };

  return (
    <section className="competitive-exam-card">
      <div className="competitive-exam-card__header">
        <h3>Select Competitive Exams</h3>

        <span className="competitive-exam-card__count">
          {selectedExams.length}
        </span>
      </div>

      <div className="competitive-exam-card__options">
        {exams.map((item) => {
          const isSelected = selectedExams.includes(item.exam);

          return (
            <label
              key={item.exam}
              className={`exam-option ${
                isSelected ? "exam-option--selected" : ""
              }`}
            >
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => handleExamChange(item.exam)}
              />

              <span className="exam-option__checkbox">{isSelected && "✓"}</span>

              <span className="exam-option__label">{item.exam}</span>
            </label>
          );
        })}
        <section className={"start_chart_wrapper"} onClick={handleOpenPopup}>
          <h5 className="start_text">Subscribe</h5>
        </section>
      </div>
    </section>
  );
};
